import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AccountSettings } from "@aws-amplify/ui-react";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { Stack, Typography } from "@mui/material";
import { GlobalContext } from "store/globalContext";

export const Profile = () => {
  const navigate = useNavigate();
  const { showWarning } = useContext(GlobalContext);
  const handleSuccess = () => {
    showWarning({
      title: (
        <Stack justifyContent={"center"} alignItems={"center"} gap={3}>
          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
            Success
          </Typography>
        </Stack>
      ),
      content: <>Password updated successfully</>,
    });
    navigate("/");
  };

  return (
    <CommonOutletTemplate title="Password Change">
      <AccountSettings.ChangePassword onSuccess={handleSuccess} />
    </CommonOutletTemplate>
  );
};
